import Albums from "./Albums";
import Helpers from "../inc/Helpers";
import Ajax from "../inc/Ajax";
import datepicker from "js-datepicker";

class Common {
    constructor() {
        this.albums = new Albums();
        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.defaultHeader = $(".default-header");
        this.mobileOverlay = $(".mobile-overlay");

        this.cookieConsentWillAppear =
            document.cookie.indexOf("cookieconsent_status=") === -1;
    }

    init() {
        let self = this;

        self.pageLoading();
        self.goToTop();
        self.limitInputCharacters();
        self.inputDatepickers();
        self.togglePasswords();
        self.menuDropdown();
        self.mobileHeaderDropdowns();
        self.btnsDeletePrompt();
        self.cardProfileCarouselSwipe();
        self.initTawkTo();
    }

    pageLoading() {
        let pageLoader = $(".page-loader");
        pageLoader.fadeOut(150);
    }

    goToTop() {
        let triggerBtn = $(".go-to-top span");

        triggerBtn.on("click", function() {
            $("html, body").animate(
                {
                    scrollTop: 0
                },
                300
            );
        });

        $(window).on("scroll", function() {
            let scrollTop = $(window).scrollTop();

            if (scrollTop > 100) {
                triggerBtn.css("display", "inline-block");
            } else {
                triggerBtn.fadeOut(200);
            }
        });
    }

    limitInputCharacters() {
        let self = this;

        let limitedInputs = $(".jr-limit-characters");

        self.helpers.limitInputCharacters(limitedInputs);
    }

    inputDatepickers() {
        let options = {
            customMonths: [
                "Janvier",
                "Fevrier",
                "Mars",
                "Avril",
                "Mai",
                "Juin",
                "Juillet",
                "Août",
                "Septembre",
                "Octobre",
                "Novembre",
                "Décembre"
            ],

            customDays: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],

            startDay: 1,

            formatter: function(input, date, instance) {
                const value = date.toLocaleDateString("FR");
                input.value = value;
            },

            onSelect: function(instance, date) {
                instance.el.classList.remove("error");

                if (typeof instance.el.nextSibling.style !== "undefined") {
                    instance.el.nextSibling.style.display = "none";
                }
            }
        };

        const picker = datepicker(".datepicker", options);

        picker.setMin(new Date());
    }

    togglePasswords() {
        let self = this;

        $("body").on("click", ".fa-eye, .fa-eye-slash", function() {
            let togglerIcon = $(this);
            self.helpers.showHidePassword(togglerIcon);
        });
    }

    menuDropdown() {
        let self = this;

        let dropdownMenuTogglers = $(".menu-item.dropdown .toggler");

        dropdownMenuTogglers.on("click", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let submenu = thisBtn.siblings(".submenu");

            submenu.fadeToggle(150);
            self.helpers.hideElementOnOutsideClick(submenu, thisBtn, "", 150);
        });
    }

    mobileHeaderDropdowns() {
        let self = this;

        let dropdownTriggers = self.defaultHeader.find(
            ".row.mobile .col-menu .dropdown-trigger-icon"
        );
        let closeBtn = self.defaultHeader.find(".row.mobile .col-menu .close");
        let keywordSearchSubmit = self.defaultHeader.find(
            "form.keyword-search .btn-mobile-search"
        );
        let mobileSearch = self.defaultHeader.find(".mobile-search");
        let mobileMenu = self.defaultHeader.find(".mobile-menu");

        const closeDropdowns = function() {
            self.defaultHeader.removeClass("forced-blue");
            self.mobileOverlay.fadeOut(150);
            dropdownTriggers.show();
            closeBtn.hide();
            mobileSearch.fadeOut(150);
            mobileMenu.fadeOut(150);
            self.albums.toggleSlickArrows("show");
        };

        dropdownTriggers.on("click", function() {
            let thisBtn = $(this);

            self.defaultHeader.addClass("forced-blue");
            self.mobileOverlay.fadeIn(150);
            self.albums.toggleSlickArrows("hide");
            dropdownTriggers.hide();
            closeBtn.show();

            if (thisBtn.is(".btn-mobile-search")) {
                mobileSearch.fadeIn(150);
            } else if (thisBtn.is(".btn-mobile-menu")) {
                mobileMenu.fadeIn(150);
            }
        });

        closeBtn.on("click", function() {
            closeDropdowns();
        });

        self.mobileOverlay.on("click", function() {
            closeDropdowns();
        });

        keywordSearchSubmit.on("click", function() {
            let thisBtn = $(this);
            let form = thisBtn.closest("form");

            form.trigger("submit");
        });
    }

    btnsDeletePrompt() {
        $("body").on("click", ".delete:not(.no-prompt)", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let confirmBtn = thisBtn.siblings(".confirm");
            let cancelBtn = thisBtn.siblings(".cancel");

            thisBtn.hide();
            confirmBtn.show();
            cancelBtn.show();

            cancelBtn.one("click", function(e) {
                e.preventDefault();

                thisBtn.show();
                confirmBtn.hide();
                cancelBtn.hide();
            });
        });
    }

    cardProfileCarouselSwipe() {
        let theCarousels = $(".card-profile .carousel");
        let touchstartX = 0;
        let touchendX = 0;

        const handleGesture = function(carousel) {
            if (touchendX < touchstartX) {
                carousel.carousel("next");
            }

            if (touchendX > touchstartX) {
                carousel.carousel("prev");
            }
        };

        theCarousels.on("touchstart", function(e) {
            touchstartX = e.changedTouches[0].screenX;
        });

        theCarousels.on("touchend", function(e) {
            let thisCarousel = $(this);

            touchendX = e.changedTouches[0].screenX;

            handleGesture(thisCarousel);
        });
    }

    isOnMobile() {
        let windowWidth = $(window).width();

        return windowWidth < sarypak.breakpoints.md;
    }

    initTawkTo(force) {
        let self = this;
        let isOnMobile = self.isOnMobile();
        let currentRouteName = sarypak.PHPToJS.routes.currentName;
        let canDirectlyShowTawkTo = !self.helpers.inArray(currentRouteName, [
            "homepage",
            "search_results",
            "announcements"
        ]);

        // if (self.cookieConsentWillAppear) {
        //     return;
        // }

        if (!force && isOnMobile && !canDirectlyShowTawkTo) {
            return;
        }

        var Tawk_API = Tawk_API || {},
            Tawk_LoadStart = new Date();
        (function() {
            var s1 = document.createElement("script"),
                s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = "https://embed.tawk.to/5af6d7a85f7cdf4f053423ac/1dhe9omi6";
            s1.charset = "UTF-8";
            s1.setAttribute("crossorigin", "*");
            s0.parentNode.insertBefore(s1, s0);
        })();
    }
}

export default Common;
